<div class="infowindow__content--dvf text--center" data-info-window>
    <i class="icon icon-search text--h1 text--primary"></i>
    <div class="text--big margin-bottom">Pour voir d’autres biens vendus, déplacez-vous sur la carte ou utilisez les filtres</div>
</div>
